module.exports = __webpack_public_path__ + "static/media/no-poets-dont-own-words3.82be7017.jpg";